import App from './App.vue';
import router from './router';
import { createApp, provide, h } from 'vue';
import { createPinia } from 'pinia';
import { useUserStore } from '@/store/user';
import { useUploadsStore } from '@/store/uploads';
import { useBaseSpaceStore } from '@/store/basespace';
import apolloClient from './apollo/client';
import { DefaultApolloClient } from '@vue/apollo-composable';
import '@fontsource/material-symbols-outlined';
// import '@fontsource/material-symbols-rounded';
// import '@fontsource/material-symbols-sharp';
import '@fortawesome/fontawesome-free/css/all.min.css';
import { library } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { fas } from '@fortawesome/free-solid-svg-icons';
import { fab } from '@fortawesome/free-brands-svg-icons';
library.add(fas, fab);

// Import plugins
import '@/plugins/dayjs';

// Bootstrap imports
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-vue-next/dist/bootstrap-vue-next.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import BootstrapVueNext, { BTooltip } from 'bootstrap-vue-next';
import 'bootstrap-icons/font/bootstrap-icons.css';

// Create the app
const app = createApp({
  setup() {
    provide(DefaultApolloClient, apolloClient);
  },
  render: () => h(App),
});
const pinia = createPinia();

app.use(pinia);
app.use(BootstrapVueNext);
app.directive('b-tooltip', BTooltip);
app.component('font-awesome-icon', FontAwesomeIcon);

const userStore = useUserStore();
await userStore.initKeycloak();

app.use(router);

useUploadsStore(); // must be initialized after the router
useBaseSpaceStore();

app.mount('#app');
